'use client'

// import { usePathname } from '@repo/shared/i18n'
import { useEffect } from 'react'

export const ScrollReset = () => {
  // const pathname = usePathname()

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    }, 500)
  }, [])
  return <></>
}
